<template>
    <div class="panel-tag mb-0 pl-3 pr-3">
        <div class="row">
            <div class="col-4">
                Умови оплати (в тендері):
            </div>
            <div class="col-8">
                {{tender_payment}}
            </div>
        </div>
        
        <div class="row">
            <div class="col-4">
                Умови поставки (в тендері):
            </div>
            <div class="col-8">
                {{tender_delivery}}
            </div>
        </div>
        
            
        <div class="row">
            <div class="col-4">
                Строк поставки (в тендері):
            </div>
            <div class="col-8">
                {{tender?.date_delivery}}
            </div>
        </div>
        
        <div class="row">
            <div class="col-4">
                Курс валют
            </div>
            <div class="col-8">
                {{ rate_type }}
            </div>
        </div>
            
    </div>
</template>

<script>
export default {
    name: "protocol_inside_payment",
    props : {
        protocol : {
            type : Object
        }
    },
    
    methods : {

    },
    
    computed : {
        tender() {
            return this.protocol?.tender;
        },
        
        tender_payment() {
            return this.tender?.payment_name;
        },
        
        tender_delivery() {
            return this.tender?.delivery_name;
        },
        
        rate_type () {
            return this.protocol.rate_from_protocol === 0 ? 'з заявок' : 'нацбанк';
        },
    },
}
</script>


<style scoped>

</style>